import {
  tenantEdgeUrlOptionsFromTenant,
  type TenantEdgeUrlOptions,
} from "../../shared/edgeUrl";
import { config } from "../environment";

export function tenantEdgeUrlOptionsForTenant(tenant: {
  edgeOrigin: string;
  edgeWildcardDomain: string | null;
}): TenantEdgeUrlOptions {
  return tenantEdgeUrlOptionsFromTenant(tenant, config);
}

// Mirrors the backend-minted callback so popup listeners and existing
// connector registration fields preserve legacy compatibility.
export function connectorOauthRedirectBase(apiOrigin: string): string {
  const path = config.legacyApiSubdomain
    ? "/connected-apps/oauth/"
    : "/connectors/oauth/";
  return `${apiOrigin}${path}`;
}

export function connectorOauthRedirectUri(
  identifier: string,
  apiOrigin: string
): string {
  return `${connectorOauthRedirectBase(apiOrigin)}${encodeURIComponent(identifier)}/callback`;
}

export function zeroSyncUrl(tenantOrigin: string): string {
  return config.zeroSyncUrl || tenantOrigin;
}
